export const TITLE = "activation.topics.collision.modal.title";
export const SUBTITLE = "activation.topics.collision.modal.subtitle";
export const USED = "activation.topics.collision.modal.used";
export const ENTER_CUSTOM_NAME = "activation.topics.collision.modal.new-name";
export const SKIP = "activation.topics.collision.modal.skip";
export const SUBMIT = "common.submit";
export const TOOLTIP = "activation.topics.collision.modal.tooltip";
export const MAX_LENGTH_TEXT = "activation.topics.collision.modal.max-length";
export const ALLOWED_CHARS = "activation.topics.collision.modal.allowed-chars";
export const NAME_USED = "activation.topics.collision.modal.name-used";
export const DUPLICATE = "activation.topics.collision.modal.name-dup-in-form";
export const PLACEHOLDER = "activation.topics.collision.modal.input.placeholder";
